// extracted by mini-css-extract-plugin
export default {"container":"overview-tab_container__AivG8","loading":"overview-tab_loading__XCq1G"};